import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import {
  frequencyFinancialTransactionsOptions,
  knowledgeFinancialAssetsOptions,
} from '@app/forms/subscription/services/ref';

@Component({
    selector: 'financial-market',
    templateUrl: './financial-market.component.html',
    styleUrls: ['./financial-market.component.scss'],
    standalone: false
})
export class FinancialMarketComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  knowledgeFinancialOptions = knowledgeFinancialAssetsOptions;
  frequencyFinancialOptions = frequencyFinancialTransactionsOptions;
  constructor(
    protected formConstructor: PrFormConstructor,

    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this, 'accountInformations');
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
